import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-xs">
      <ol className="flex items-center flex-wrap gap-1.5 font-mono uppercase tracking-widest text-muted-foreground">
        <li className="flex items-center">
          <Link to="/" className="hover:text-foreground transition-colors flex items-center gap-1">
            <Home className="w-3 h-3" /> Home
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={it.path || it.name} className="flex items-center gap-1.5">
            <ChevronRight className="w-3 h-3 opacity-50" />
            {it.path && i < items.length - 1 ? (
              <Link to={it.path} className="hover:text-foreground transition-colors">
                {it.name}
              </Link>
            ) : (
              <span className="text-foreground truncate max-w-[240px]">{it.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
